const initialisation={authData:null};

const reducerAuth=(state=initialisation,action)=>{
    switch (action.type){
        case 'AUTH':
            localStorage.setItem('profiles',JSON.stringify({...action?.data}))
            return {...state,authData:action?.data};
        case 'LOGOUT':
            localStorage.clear();
            return {...state,authData:null}
        default:
            return state;
    }
}

export default reducerAuth;